module.exports = __webpack_public_path__ + "static/media/view award category.0e16be2d.svg";